import {showAlert} from '../actions/miscellaneousActions';
import {get, post} from '../HTTP';
import {UserModuleModel} from '../model/UserModulesModel';
import {getCurrentUserUUID} from '../utils/generalUtils';
import { getUserData } from './utilityServices';

export async function getAllUserModules() {
    try { 
        const userData = getUserData();
        const category = userData.category || 'all';
        UserModuleModel.deleteAllInstances();
        const response = await get(`/GetAllUsersModules/${category}`, {});
        const moduleIds = [];
        (response.data || []).map(instance => {
            if (moduleIds.indexOf(instance.UniqueID) < 0) {
                instance.id = instance.UniqueID;
                instance.modulesCount = instance.Modules && instance.Modules.length;
                instance.AccessLevel = instance.Access_Level;
                new UserModuleModel(instance).$save();
            }
        });
    } catch (error) {
        showAlert({
                title: 'Oops..!!',
                text: error,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw new Error(error);
    }
}

export async function updateUserModule(userID: string, userName: string, modules: Array<any>, Completed: string[], instance) {
    const data = {
        AdminId: getCurrentUserUUID(),
        UserModules: [
            {
                EmployeeId: userID,
                Modules: modules,
                Completed
            }
        ]
    };
    try {
        const response = await post(`/AssigningModules`, data);
        await getAllUserModules();
        showAlert({
            title: 'Success...!!',
            text: `User ${userName}'s Modules are Updated.`,
            type: 'success',
            closeOnConfirm: true,
            confirmCallback: () => {
                instance.setState({
                    isLoading: false
                });
            }
        }, 'submission', 5000);
    } catch (error) {
        showAlert({
                title: 'Oops..!!',
                text: error,
                type: 'error',
                closeOnConfirm: true,
                confirmCallback: () => {
                    instance.setState({
                        isLoading: false
                    });
                }
            },
            'submission');
        throw new Error(error);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/userModuleService.ts